import { configureStore } from '@reduxjs/toolkit';
import contentReducer from './content';
import localReducer   from './local';   
import eventsReducer from "./eventsSlice";
import mediaReducer from "./media";
import authSliceReducer from "./auth"
import commentsSliceReducer from './commentsSlice';



export const store = configureStore({
  reducer: {
    content: contentReducer,
    local:   localReducer,   
    events: eventsReducer, 
    media: mediaReducer,
    auth: authSliceReducer,
    comments: commentsSliceReducer,
  },
});
